import {Tooltip} from "@mui/material";
import React, {useRef, useState, useEffect} from "react";

// https://stackoverflow.com/a/61318377
// adjusted to use a `title` prop instead of having an identical title as children
// adjusted to avoid null/undefined errors when the element is not found on the page
export const OverflowTip = ({title, children}) => {
	const [isOverflowed, setIsOverflow] = useState(false);
	const textElementRef = useRef();
	useEffect(() => {
		setIsOverflow(textElementRef.current?.scrollWidth > textElementRef.current?.clientWidth);
	}, []);
	return (
		<Tooltip title={title} disableHoverListener={!isOverflowed}>
			<div
				ref={textElementRef}
				style={{
					whiteSpace: "nowrap",
					overflow: "hidden",
					textOverflow: isOverflowed ? "ellipsis" : undefined,
				}}
			>
				{children}
			</div>
		</Tooltip>
	);
};
